module.exports = __webpack_public_path__ + "d3d8c7f3aea88e7f6261646205a329f7.png";